const SESSION_ID_KEY = "uklid-telemetry-session-id";
const SESSION_USER_KEY = "uklid-telemetry-session-user";
const SEQUENCE_KEY = "uklid-telemetry-sequence";
const ACTIVE_WORKFLOW_ATTEMPT_KEY = "uklid-telemetry-workflow-attempt";

export interface TelemetrySessionContext {
  sessionId: string;
  sequence: number;
}

export function ensureTelemetrySession(userId: string): TelemetrySessionContext {
  const storedUser = sessionStorage.getItem(SESSION_USER_KEY);
  let sessionId = sessionStorage.getItem(SESSION_ID_KEY);
  let sequence = Number.parseInt(sessionStorage.getItem(SEQUENCE_KEY) ?? "0", 10);

  if (storedUser !== userId || !sessionId || !Number.isFinite(sequence)) {
    sessionId = crypto.randomUUID();
    sequence = 0;
    sessionStorage.setItem(SESSION_USER_KEY, userId);
    sessionStorage.setItem(SESSION_ID_KEY, sessionId);
    sessionStorage.setItem(SEQUENCE_KEY, "0");
    sessionStorage.removeItem(ACTIVE_WORKFLOW_ATTEMPT_KEY);
  }
  return { sessionId, sequence };
}

export function advanceTelemetrySequence(userId: string): TelemetrySessionContext {
  const session = ensureTelemetrySession(userId);
  sessionStorage.setItem(SEQUENCE_KEY, String(session.sequence + 1));
  return session;
}

export function beginWorkflowAttempt(workflowName: string): string {
  const id = crypto.randomUUID();
  sessionStorage.setItem(ACTIVE_WORKFLOW_ATTEMPT_KEY, JSON.stringify({ id, workflowName }));
  return id;
}

export function getActiveWorkflowAttemptId(): string | null {
  try {
    const raw = sessionStorage.getItem(ACTIVE_WORKFLOW_ATTEMPT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { id?: unknown };
    return typeof parsed.id === "string" ? parsed.id : null;
  } catch {
    return null;
  }
}

export function clearWorkflowAttempt(): void {
  sessionStorage.removeItem(ACTIVE_WORKFLOW_ATTEMPT_KEY);
}

export function getClientVersion(): string {
  return import.meta.env.VITE_APP_VERSION || "0.1.0";
}
